export const PASSING_RATING = 75;
